import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { DataViewModule } from "primeng/dataview";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { TabViewModule } from "primeng/tabview";

import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { PortalAppsComponent } from "./components/portal-apps.component";
import { ParentPortalAppRegComponent } from "./parent-portal-app-reg/parent-portal-app-reg.component";
import { StudentPortalAppRegComponent } from "./student-portal-app-reg/student-portal-app-reg.component";
import { StaffPortalAppRegComponent } from "./staff-portal-app-reg/staff-portal-app-reg.component";
import { PortalAppBatchRegistrationComponent } from "./portal-app-batch-registration/portal-app-batch-registration.component";
import { PortalAppNotificationsComponent } from "./portal-app-notifications/portal-app-notifications.component";
import { ParentPortalByParentModeComponent } from "./parent-portal-app-reg/parent-portal-by-parent-mode/parent-portal-by-parent-mode.component";
import { ParentPortalByStudentModeComponent } from "./parent-portal-app-reg/parent-portal-by-student-mode/parent-portal-by-student-mode.component";
import { DataService_Parent_PortalAppReg } from "./parent-portal-app-reg/shared/data.service";
import { DataService_Student_PortalAppReg } from "./student-portal-app-reg/shared/data.service";
import { DataService_Staff_PortalAppReg } from "./staff-portal-app-reg/shared/data.service";
import { PortalAppBatchEmailLogComponent } from "./portal-app-batch-registration/portal-app-batch-email-log/portal-app-batch-email-log.component";
import { PortalAppBatchExportComponent } from "./portal-app-batch-registration/portal-app-batch-export/portal-app-batch-export.component";
import { PortalAppBatchImportComponent } from "./portal-app-batch-registration/portal-app-batch-import/portal-app-batch-import.component";
import { PortalAppBatchImportTableComponent } from "./portal-app-batch-registration/portal-app-batch-import-table/portal-app-batch-import-table.component";
import { DataService_PortalAppBatchRegistration } from "./portal-app-batch-registration/shared/data.service";
import { DataService_PortalAppBatchNotify } from "./portal-app-notifications/shared/data.service";
import { PanicAlertTopicMaintenanceComponent } from "./panic-alert-topic-maintenance/panic-alert-topic-maintenance.component";
import { DataService_TopicMaintenance } from "./panic-alert-topic-maintenance/shared/data.service";
import { PanicAlertPersonTableComponent } from "./panic-alert-topic-maintenance/panic-alert-person-table/panic-alert-person-table.component";
import { PanicAlertTopicModifyComponent } from "./panic-alert-topic-maintenance/panic-alert-topic-modify/panic-alert-topic-modify.component";
import { PanicAlertPersonAssignComponent } from "./panic-alert-topic-maintenance/panic-alert-person-table/panic-alert-person-assign/panic-alert-person-assign.component";
import { TopicStaffToAddComponent } from "./panic-alert-topic-maintenance/panic-alert-person-table/panic-alert-person-assign/topic-staff-to-add/topic-staff-to-add.component";
import { PortalAppNotificationLogComponent } from "./portal-app-notification-log/portal-app-notification-log.component";
import { DataService_PortalAppNotificationLog } from "./portal-app-notification-log/shared/data.service";
import { PanicAlertMaintenanceComponent } from "./panic-alert-maintenance/panic-alert-maintenance.component";
import { DataService_PanicAlertMaintenance } from "./panic-alert-maintenance/shared/data.service";

@NgModule({
	declarations: [
		PortalAppsComponent,
		ParentPortalAppRegComponent,
		StudentPortalAppRegComponent,
		StaffPortalAppRegComponent,
		PortalAppBatchRegistrationComponent,
		PortalAppNotificationsComponent,
		ParentPortalByParentModeComponent,
		ParentPortalByStudentModeComponent,
		PortalAppBatchEmailLogComponent,
		PortalAppBatchExportComponent,
		PortalAppBatchImportComponent,
		PortalAppBatchImportTableComponent,
		PanicAlertTopicMaintenanceComponent,
		PanicAlertPersonTableComponent,
		PanicAlertTopicModifyComponent,
		PanicAlertPersonAssignComponent,
		TopicStaffToAddComponent,
		PortalAppNotificationLogComponent,
		PanicAlertMaintenanceComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		SchoolselectorModule,
		DataViewModule,
		TabViewModule,
	],
	providers: [
		ConfirmationService,
		DataService_Parent_PortalAppReg,
		DataService_Student_PortalAppReg,
		DataService_Staff_PortalAppReg,
		DataService_PortalAppBatchRegistration,
		DataService_PortalAppBatchNotify,
		DataService_TopicMaintenance,
		DataService_PortalAppNotificationLog,
		DataService_PanicAlertMaintenance,
	],
})
export class PortalAppsModule {}
